import { FC, useEffect } from "react";
import { ReactComponent as FiltrationTickIcon } from "images/FiltrationTickIcon.svg";
import styles from "./EnumListFiltration.module.sass";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeCurrentEnumList, ChangeFiltrationValue } from "toolkit/steps/stepThree/stepThree.slice";
import { IEnumList } from "toolkit/steps/stepThree/stepThree.types";
import { convertDate } from "helpers";
import { useLocation } from "react-router-dom";

export const EnumListFiltration: FC = () => {
	const { filtrationValue, allEnumList, mainEnumList, currentEnumList } = useAppSelector((state) => state.stepThree);
	const location = useLocation();

	const dispatch = useAppDispatch();

	const changeCurrentEnumList = (e: any, EnumList: any) => {
		if (EnumList.id === currentEnumList?.id) return;
		dispatch(ChangeCurrentEnumList({ EnumList, value: e.target.innerText }));
		// setFiltration(e.target.innerText);
	};

	useEffect(() => {
		dispatch(
			ChangeFiltrationValue(`Перечень “${mainEnumList?.listName}” от ${convertDate(mainEnumList!.creationDate)}`),
		);
		//eslint-disable-next-line
	}, []);
	useEffect(() => {
		if (location.state?.outline && allEnumList) {
			const findingEnum = allEnumList.find((_) => _.id === location.state.outline);
			if (findingEnum) {
				changeCurrentEnumList(
					{
						target: {
							innerText: `Дополнение в перечень “${findingEnum?.listName}” от ${convertDate(
								findingEnum?.creationDate,
							)}`,
						},
					},
					findingEnum,
				);
				location.state = null;
			}
		}
		//eslint-disable-next-line
	}, [allEnumList, location.state]);
	return (
		<div className={styles["filtration-wrp"]}>
			<button className={styles["filtration-btn"]}>
				<span className={styles["filtration-name"]}>{filtrationValue} </span>
				<div>
					<FiltrationTickIcon />
				</div>
			</button>
			<div className={styles.filtration}>
				<button onClick={(e) => changeCurrentEnumList(e, mainEnumList)} className={styles["filtration-item"]}>
					Перечень “{mainEnumList?.listName}” от {convertDate(mainEnumList!.creationDate)}
				</button>
				{allEnumList.map(
					(enumList: IEnumList) =>
						enumList.type !== 1 && (
							<button
								key={enumList.id}
								onClick={(e) => changeCurrentEnumList(e, enumList)}
								className={styles["filtration-item"]}>
								Дополнение в перечень “{enumList?.listName}” от {convertDate(enumList?.creationDate)}
							</button>
						),
				)}
			</div>
		</div>
	);
};
